import { showroomApi } from './api';

export const getUnits = async () => showroomApi.QUERY_GET('/size-mappings')({});
